import { DISPLAY_DATE_WITH_TIME } from "@constants/date-formats";
import { formatDateToString } from "@utils/date-util";
import { RefreshResult } from "@idw-types/common";
import { IdwTable } from "../../common/idw-table/idw-table";
import styles from "./refresh-results-container.less";
import { resources } from "@constants/hardcoded-strings";
import { createColumnHelper, getCoreRowModel, useReactTable } from "@tanstack/react-table";
import { useMemo } from "react";

type RefreshResultsContainerProps = {
    lastRefreshDate: Date;
    refreshResults: Array<RefreshResult>;
}

export const RefreshResultsContainer = (props: RefreshResultsContainerProps) => {
    const { lastRefreshDate, refreshResults } = props;
    const displayDate = formatDateToString(lastRefreshDate, DISPLAY_DATE_WITH_TIME);

    const columnHelper = createColumnHelper<RefreshResult>();
    const columns = useMemo(() => ([
        columnHelper.accessor("status", {
            header: resources.tables.refreshResults.columns.status.header
        }),
        columnHelper.accessor("message", {
            header: resources.tables.refreshResults.columns.message.header
        })
    ]), [refreshResults]);

    const useTableResult = useReactTable({
        columns,
        data: refreshResults,
        filterFns: null,
        enableFilters: false,
        sortDescFirst: false,
        getCoreRowModel: getCoreRowModel()
    });

    //todo - replace hardcoded strings
    return (
        <div className={styles.refreshResultsContainer}>
            <div className={styles.textLine}><b>Refreshed at:&nbsp;</b>{displayDate}</div>
            <div className={styles.refreshResultsTableContainer}>
                <IdwTable
                    id="refresh-results"
                    useTableResult={useTableResult}
                    headerColumnKeyPrefix={"refresh-results"}
                    className={styles.refreshResultsTable}
                />
            </div>
        </div>
    );
};